import { Status } from './status';
import { SizeGroup } from './style';

export class ShotType {
	id?: number;
	name?: string;
	code?: string;

	constructor(init?: Partial<ShotType>) {
		Object.assign(this, init);
	}
}

export class CodifiedUse {
	id?: number;
	name?: string;
	code?: string;

	constructor(init?: Partial<CodifiedUse>) {
		Object.assign(this, init);
	}
}

export class MediaFormat {
	id?: number;
	name?: string;
	code?: string;

	constructor(init?: Partial<MediaFormat>) {
		Object.assign(this, init);
	}
}

export class AspectRatio {
	id?: number;
	label?: string;
	orientation?: string;

	constructor(init?: Partial<AspectRatio>) {
		Object.assign(this, init);
	}
}

export enum ShotApprovalStatus {
	NotUploaded = 1,
	Uploaded = 2,
	Approved = 3,
	Rejected = 4,
	ToReshoot = 5
}

export class Shot {
	id?: number;
	file?: File;
	status?: Status;
	mandatory?: boolean;
	estimatedFileName?: string;
	imgPath?: string;
	shotApprovalStatus?: ShotApprovalStatus;
	codifiedUse?: CodifiedUse;
	mediaFormat?: MediaFormat;
	aspectRatio?: AspectRatio;
	shotType?: ShotType;
	colorId?: number;
	colorName?: string;
	modelId?: number;
	sizeGroup?: SizeGroup;
	isAi?: boolean;

	constructor(init?: Partial<Shot>) {
		Object.assign(this, init);
	}
}
